<template>
    <SideNavLayout :hideSidebar="!sessionStoreState.authenticated">

        <template v-slot:menu>
            <Menu></Menu>
        </template>

        <template v-slot:navbar>
            <NavBar></NavBar>
        </template>
        <template v-slot:content>
            <div class="m-1">
                <router-view/>
            </div>
        </template>
    </SideNavLayout>
</template>

<script>
  import NavBar from '@/components/NavBar.vue'
  import SideNavLayout from '@/components/sidenav/SideNavLayout.vue'
  import Menu from '@/components/sidenav/Menu.vue'
  import SessionStore from '@/stores/SessionStore'

  export default {
    name: 'App',
    components: {
      Menu,
      NavBar,
      SideNavLayout
    },
    data() {
      return {
        sessionStoreState: SessionStore.state
      }
    },
  }
</script>

